import { render, staticRenderFns } from "./CompetenceEditDialog.vue?vue&type=template&id=594e0119&scoped=true"
import script from "./CompetenceEditDialog.vue?vue&type=script&lang=js"
export * from "./CompetenceEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594e0119",
  null
  
)

export default component.exports